var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-alert", { attrs: { value: _vm.value, type: "warning" } }, [
    _vm._v(
      "\n  Strict data validation is enabled for this column. This means that every row inside the raw data file must have a\n  non-empty value to pass validation.\n"
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }